var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"background fixed overflow-auto inset-0 w-full h-full bg-opacity-50 z-30",class:_vm.overlayColor === 'background' ? 'bg-background' : 'bg-tertiary'},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }